module.exports = __webpack_public_path__ + "img/company-6.4a460a23.svg";